var map = {
	"./bg.json": "dcd0",
	"./cs.json": "c686",
	"./de.json": "6ce2",
	"./el.json": "f184",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./hr.json": "92d7",
	"./it.json": "0825",
	"./pl.json": "89b2",
	"./pt.json": "5d67",
	"./ru.json": "7704",
	"./sk.json": "3da9",
	"./sl.json": "d34a",
	"./sv.json": "4c5b",
	"./template.json": "5cbb",
	"./zh.json": "3504"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";